// EspecialDaCasa.js — UM livro em vitrine grande na home.
//
// O QUE ISTO SUBSTITUIU, E POR QUÊ:
// aqui existiam dois blocos lado a lado, "Continue de onde parou" e
// "Em Promoção". Os dois eram fachada: o primeiro chamava `/ebook` e mostrava
// `slice(0, 2)` da lista — ninguém nunca "continuou" nada, porque o site não
// guarda progresso de leitura; o segundo mostrava `slice(2, 4)` com um selo
// fixo de "50%" em cima de livros que não tinham desconto nenhum. Quatro capas
// minúsculas prometendo duas coisas que não aconteciam.
//
// COMO ESTE CARD FOI MONTADO:
// nada aqui é acabamento inventado. A vitrine é uma remontagem do vocabulário
// que o site já tem, no tamanho que só ela tem espaço para usar:
//   - sombra sólida deslocada que cresce no hover ....... CardDestaque
//   - borda que acende do lado do cursor ................ BorderGlow
//   - brilho que segue o cursor na superfície ........... SpotlightCard
//   - estrelas de avaliação ............................. Stars + notaExibida
//   - contador que sobe ao entrar na tela ............... CountUp
//   - botão laranja em relevo (contorno e sombra no
//     laranja escuro) ................................... CardDestaque
//   - coração translúcido em cima da capa ............... CardDestaque
//   - sublinhado que cresce do centro ................... .link-sublinhado
//   - fita de curadoria ................................. selo do CardDestaque
// O SpotlightCard estava no projeto sem nenhum uso: ele ilumina a SUPERFÍCIE e
// o BorderGlow ilumina a BORDA. Os dois juntos em cima de uma capa pequena
// viram festa (é o que diz o comentário do BorderGlow); numa superfície grande
// como esta, um completa o outro.
//
// O card NÃO é um <Link> inteiro. Ele tem botões dentro (coração, trecho), e
// aninhar botão em link deixa o teclado e o leitor de tela sem saber o que
// está ativando. Quem leva à página do livro são a capa, o título, o
// "Ler mais" e o "Ver mais".
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import useHomeConfig from "../../../hooks/useHomeConfig";
import { camposDePreco } from "../../../utils/precoLivro";
import PrecoComDesconto from "../../ui/PrecoComDesconto";
import Reveal from "../../ui/Reveal";
import Vitrine from "../vitrine/Vitrine";
import BorderGlow from "../../ui/BorderGlow";
import SpotlightCard from "../../ui/SpotlightCard";
import CountUp from "../../ui/CountUp";
import Stars from "../paginaProduto/Stars";
import { notaDoLivro } from "../paginaProduto/notaExibida";
import ModalPreview from "../paginaProduto/ModalPreview";
import { CarrinhoContext } from "../../../services/context/CarrinhoContext";
import { useModal } from "../../../services/context/ModalContext";

// Pílula de ficha técnica (páginas, idioma, edição).
const Ficha = ({ icone, children }) => (
  <span
    className="inline-flex items-center gap-1.5 rounded-controle border border-line bg-insigne-navy-deep/70
               px-2.5 py-1 text-xs text-white/65"
  >
    <i className={"bi " + icone + " text-insigne-orange"} />
    {children}
  </span>
);

const EspecialDaCasa = () => {
  const config = useHomeConfig();
  const livro = config?.especial || null;

  const API_URL = process.env.REACT_APP_API;
  const main = process.env.REACT_APP_MAIN;

  const { adicionarItem, toggleDesejo, estaNaLista } = useContext(CarrinhoContext);
  const { openModal } = useModal();

  // TODOS os hooks antes de qualquer `return`: o livro chega depois da
  // requisição, e sair mais cedo mudaria a quantidade de hooks entre renders.
  const [isHover, setIsHover] = useState(false);
  const [capaCarregada, setCapaCarregada] = useState(false);
  const [trechoAberto, setTrechoAberto] = useState(false);

  // Sem livro escolhido no painel, a seção inteira some — é assim que o admin
  // tira o bloco do ar: basta limpar o campo.
  if (!livro) return null;

  const {
    id, titulo, subtitulo, image, sinopse, categorias, pdf, autores,
    preco, quantidade, frete, views, numero_paginas, edicao, idioma,
  } = livro;

  // Mesma regra do card: autores podem vir como objeto ou string, e valores
  // nulos existem na base.
  const nomesAutores = Array.isArray(autores)
    ? autores
        .filter(Boolean)
        .map((a) => (typeof a === "object" ? a.nome : a))
        .filter((n) => typeof n === "string" && n.trim() !== "")
    : [];

  const generos = Array.isArray(categorias) ? categorias.filter(Boolean) : [];
  const texto = typeof sinopse === "string" ? sinopse.trim() : "";

  // A nota vem embutida no /home-config, junto com o livro. Antes esta seção
  // chamava /ebook/{id}/avaliacoes só para desenhar cinco estrelas — uma
  // requisição a mais na home inteira por causa de uma linha de texto.
  const { nota, total, semAvaliacoes, atenuada } = notaDoLivro(livro);

  const isFav = estaNaLista ? estaNaLista(id) : false;
  const precoValido = preco && !isNaN(parseFloat(preco)) && parseFloat(preco) > 0;

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const linkLivro = main + "livros/" + id;

  // Carrinho e lista de desejos usam EXATAMENTE a mesma chamada do
  // CardDestaque: a vitrine não pode se comportar diferente do card comum.
  const aoAdicionar = () => {
    if (!precoValido) return;
    // `formato` do item = QUAL VERSÃO está sendo comprada, e todo card vende
    // o digital (usa `livro.preco`; o impresso é `preco_impresso`, escolhido
    // só no PrecoCard). NUNCA repassar `livro.formato` aqui: ali o campo é o
    // tamanho do impresso ("16x23 (160x230)") e foi o que quebrou o checkout
    // em 20/08/2026. O CarrinhoContext também saneia, mas a intenção fica
    // explícita na origem.
      // A nota e o autor viajam junto com o item para o carrinho poder
      // mostrá-los sem uma requisição por linha. Quem já tinha itens no
      // carrinho antes disto não tem os campos, e lá a linha de estrelas
      // simplesmente não aparece (ver a guarda em CarrinhoPage.js).
    const item = {
      // O preco que vai para o carrinho e o do SERVIDOR (precoDeVenda le
      // `preco_com_desconto`). Mandar o cheio de um livro em destaque faz o
      // checkout recusar o pedido inteiro -- ver src/utils/precoLivro.js.
      // `preco_original` viaja junto para o carrinho poder riscar o valor antigo.
      id, titulo, ...camposDePreco(livro), image, autores, formato: "ebook",
      quantidade: quantidade || 1,
      avaliacoes_avg_nota: livro.avaliacoes_avg_nota,
      avaliacoes_count: livro.avaliacoes_count,
    };
    if (frete) item.frete = frete;
    adicionarItem(item);
    openModal(item);
  };

  const aoFavoritar = () => {
    if (toggleDesejo) {
      // O preço que se cobra, e o "de" junto — ver o mesmo trecho no
      // CardDestaque. O cheio deixava a Minha Lista com um valor velho.
      toggleDesejo({
        id, titulo, image, ...camposDePreco(livro), autores, formato: "ebook",
        avaliacoes_avg_nota: livro.avaliacoes_avg_nota,
        avaliacoes_count: livro.avaliacoes_count,
      });
    }
  };

  return (
    <Vitrine
      id="especial-da-casa"
      chapeu="Escolha da editora"
      titulo="Especial da Casa"
      icone="bi-bookmark-star-fill"
      // Um livro só, escolhido no painel — ver o cabeçalho deste arquivo. A
      // frase precisa dizer isso: o valor da seção é justamente ela NÃO ser
      // automática, e o visitante não tem como saber disso olhando.
      descricao="Um título escolhido a dedo, um de cada vez. Quando a editora quer que você conheça um livro, ele aparece aqui."
    >
        <Reveal>
          {/* `raio` casa com o rounded do cartão de dentro: o BorderGlow vira
              `--raio-borda` e os pseudo-elementos herdam por
              `border-radius: inherit` (App.css). Descasar os dois deixa o anel
              de luz mais redondo que o cartão que ele abraça — foi o que
              aconteceu quando a escala de raio entrou e este número ficou para
              trás. 8 = `rounded-card`. */}
          <div className="cantoneiras">
          <BorderGlow raio={8}>
            {/* A camada que se move: transform e sombra ficam AQUI, fora do
                SpotlightCard, porque ele recorta o conteúdo (overflow-hidden)
                e a fita de curadoria precisa vazar para fora da borda. */}
            <div
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
              className={
                "relative rounded-card transition-[transform,box-shadow] duration-200 will-change-transform " +
                (isHover ? "-translate-x-[3px] -translate-y-[3px]" : "")
              }
              style={{
                boxShadow: `${isHover ? 7 : 4}px ${isHover ? 7 : 4}px 0 0 rgb(var(--c-sombra))`,
              }}
            >
              {/* Fita de curadoria — o mesmo selo do card de destaque, para as
                  duas seções lerem como escolha da mesma editora. */}
              <span
                className="absolute -top-3 left-5 z-20 rounded-selo border-2 border-insigne-orange-dark
                           bg-insigne-orange px-3 py-0.5 text-[11px] font-bold uppercase tracking-wide text-paper"
              >
                Escolha da editora
              </span>

              <SpotlightCard
                intensidade={0.1}
                raio={420}
                className="cartao p-5 md:p-7"
              >
                <div className="grid grid-cols-1 md:grid-cols-[minmax(0,340px)_minmax(0,1fr)] gap-7 md:gap-9 items-start">
                  {/* ================= Capa =================
                      A capa é o gatilho: `capa-especial` acende as três ações
                      (coração, preço e carrinho) só quando o cursor entra nela.
                      Em aparelho de toque as três ficam sempre visíveis — a
                      regra está no `.capa-acao-hover` do App.css. */}
                  <div className="max-w-[360px] w-full mx-auto md:mx-0">
                    {/* Esta div envolve SÓ a capa — é a âncora das três ações.
                        Com o contador de visualizações dentro dela, o
                        `bottom-3` passaria a contar a partir do fim do
                        contador e as ações vazariam para fora da capa. */}
                    <div className="capa-especial group/capa relative">
                    <Link
                      to={linkLivro}
                      onClick={scrollUp}
                      aria-label={`Ver a página de ${titulo}`}
                      className="block relative overflow-hidden rounded-card border-2 border-insigne-sombra
                                 bg-insigne-navy-deep aspect-[3/4] transition-[box-shadow] duration-200"
                      style={{
                        // A capa repete a assinatura do card num degrau maior:
                        // vira um objeto empilhado sobre a superfície, e não
                        // uma imagem colada nela.
                        boxShadow: `${isHover ? 9 : 6}px ${isHover ? 9 : 6}px 0 0 rgb(var(--c-sombra))`,
                      }}
                    >
                      {!capaCarregada && (
                        <div className="absolute inset-0 animate-pulse bg-insigne-navy-mid/60" />
                      )}
                      <img
                        src={`${API_URL}public/${image}`}
                        alt={titulo}
                        loading="lazy"
                        onLoad={() => setCapaCarregada(true)}
                        onError={() => setCapaCarregada(true)}
                        className={
                          "relative w-full h-full object-cover transition-transform duration-500 ease-out " +
                          "group-hover/capa:scale-[1.05] " +
                          (capaCarregada ? "opacity-100" : "opacity-0")
                        }
                      />

                      {/* O véu mora DENTRO do link para ser recortado pelos
                          cantos arredondados da capa. É `aria-hidden` e não
                          captura clique, então não atrapalha o link. */}
                      <div
                        aria-hidden="true"
                        className="capa-scrim absolute inset-x-0 bottom-0 h-2/5
                                   bg-gradient-to-t from-black/85 via-black/40 to-transparent"
                      />
                    </Link>

                    {/* Coração — base translúcida porque ele fica EM CIMA da
                        capa, e opaco taparia o livro. Borda e sombra são a
                        MESMA cor (branco a 45%, subindo a 60% no hover): o
                        contorno laranja anterior brigava com a capa e não
                        pertencia a nenhum dos dois — nem ao botão, nem ao
                        livro. Coração vermelho quando salvo. */}
                    <button
                      onClick={aoFavoritar}
                      aria-label={isFav ? "Remover da Minha Lista" : "Salvar na Minha Lista"}
                      aria-pressed={isFav}
                      title={isFav ? "Remover da Minha Lista" : "Salvar na Minha Lista"}
                      className="capa-acao-hover capa-acao-topo absolute top-3 right-3 z-20 inline-flex items-center justify-center
                                 w-11 h-11 rounded-controle border-2 border-paper/45
                                 bg-paper/30 backdrop-blur-sm
                                 shadow-[3px_3px_0_0_rgb(255_255_255_/_0.45)]
                                 transition-[box-shadow,background-color,border-color] duration-150
                                 hover:bg-paper/55 hover:border-paper/60
                                 hover:shadow-[5px_5px_0_0_rgb(255_255_255_/_0.6)]"
                    >
                      <i
                        className={
                          "bi text-base " +
                          (isFav ? "bi-heart-fill text-red-500" : "bi-heart text-ink-fixed")
                        }
                      />
                    </button>

                    {precoValido && (
                      <>
                        {/* Preço em texto puro sobre o véu, sem caixa: uma
                            plaqueta opaca em cima da arte do livro lê como
                            painel de interface colado no produto. O véu já
                            garante o contraste; a sombra do texto cobre o caso
                            de uma capa clara justo naquele canto.
                            A LINHA DO PREÇO tem a altura do botão (h-11) para
                            os dois assentarem na mesma linha; o riscado, quando
                            há desconto, sobe ACIMA dela — o bloco é ancorado
                            por baixo. `right-16` deixa livre o canto do botão.
                            O desenho é o de toda vitrine: ver PrecoComDesconto.
                            Este livro é decorado pelo servidor como os outros,
                            e mostrava o CHEIO enquanto o carrinho recebia o
                            preço com desconto. */}
                        <PrecoComDesconto
                          livro={livro}
                          numero="text-2xl"
                          riscado="text-paper/75"
                          reservarRiscado={false}
                          quebrar={false}
                          linha="h-11 leading-none"
                          className="capa-acao-hover !pointer-events-none absolute bottom-3 left-3 right-16 z-20
                                     text-paper [text-shadow:0_1px_4px_rgb(0_0_0_/_0.7)]"
                        />

                        {/* Carrinho no canto oposto, quadrado do MESMO tamanho
                            do coração: os dois lêem como um par nos cantos, em
                            vez de dois enfeites de tamanhos diferentes. */}
                        <button
                          type="button"
                          onClick={aoAdicionar}
                          aria-label={`Adicionar ${titulo} ao carrinho`}
                          title="Adicionar ao carrinho"
                          className="capa-acao-hover group/cart absolute bottom-3 right-3 z-20
                                     inline-flex items-center justify-center w-11 h-11 rounded-controle
                                     border-2 border-insigne-orange-dark bg-insigne-orange text-paper
                                     shadow-[3px_3px_0_0_rgb(var(--c-orange-dark))]
                                     transition-[box-shadow,background-color] duration-150
                                     hover:bg-insigne-orange-alt
                                     hover:shadow-[5px_5px_0_0_rgb(var(--c-orange-dark))]"
                        >
                          {/* Carrinho vazio em repouso, cheio com o cursor no
                              botão: o ícone antecipa o que o clique faz. */}
                          <i className="bi bi-cart text-base group-hover/cart:hidden" />
                          <i className="bi bi-cart-fill text-base hidden group-hover/cart:inline" />
                        </button>
                      </>
                    )}

                    </div>

                    {/* Quantas pessoas já pararam neste livro. Número real da
                        base (`views`), com o mesmo contador da faixa de
                        números institucionais da home. */}
                    {views > 0 && (
                      <p className="flex items-center justify-center gap-2 mt-4 text-xs text-white/45">
                        <i className="bi bi-eye" />
                        <CountUp to={Number(views)} className="font-semibold text-white/70" />
                        <span>visualizações</span>
                      </p>
                    )}
                  </div>

                  {/* ================= Ficha ================= */}
                  <div className="min-w-0">
                    <h3 className="titulo-display mb-0 text-white text-[2.4rem] md:text-[3rem]">
                      <Link to={linkLivro} onClick={scrollUp} className="hover:text-insigne-orange transition-colors">
                        {titulo}
                      </Link>
                    </h3>
                    {subtitulo && subtitulo !== "null" && (
                      <p className="text-white/60 text-base md:text-lg mt-1 leading-snug">{subtitulo}</p>
                    )}

                    {/* Autor e opiniões na mesma linha: são as duas coisas que
                        respondem "posso confiar neste livro?". */}
                    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mt-3">
                      {nomesAutores.length > 0 && (
                        <p className="flex items-center gap-2 text-white/75 text-sm">
                          <i className="bi bi-pen-fill text-insigne-orange" />
                          {nomesAutores.join(", ")}
                        </p>
                      )}

                      {/* Nota do livro. Sem avaliação nenhuma, as cinco
                          estrelas aparecem APAGADAS e o texto diz "sem
                          avaliações" — mostram o formato sem afirmar uma nota
                          que ninguém deu. A política mora em notaExibida.js e
                          vale para o site inteiro. */}
                      <Link
                        to={linkLivro}
                        onClick={scrollUp}
                        className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors"
                      >
                        <Stars value={nota} size="text-sm" className={atenuada ? "opacity-40" : ""} />
                        <span>
                          {semAvaliacoes
                            ? "sem avaliações"
                            : `${nota.toFixed(1).replace(".", ",")} (${total})`}
                        </span>
                      </Link>
                    </div>

                    {generos.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-4">
                        {generos.map((g, i) => (
                          <span
                            key={i}
                            className="rounded-controle border border-insigne-orange/45 bg-insigne-orange/10
                                       px-3 py-1 text-xs font-semibold text-insigne-orange"
                          >
                            {g}
                          </span>
                        ))}
                      </div>
                    )}

                    {/* Ficha técnica: o que a pessoa pergunta antes de comprar
                        e hoje só descobre entrando na página do livro. */}
                    <div className="flex flex-wrap gap-2 mt-3">
                      {numero_paginas > 0 && (
                        <Ficha icone="bi-file-earmark-text">{numero_paginas} páginas</Ficha>
                      )}
                      {idioma && <Ficha icone="bi-translate">{idioma}</Ficha>}
                      {edicao && <Ficha icone="bi-layers">{edicao}ª edição</Ficha>}
                    </div>

                    {texto && (
                      <div className="mt-5">
                        <h4 className="text-xs font-bold uppercase tracking-wider text-white/45 mb-2">
                          Sobre
                        </h4>
                        {/* `whitespace-pre-line`: a sinopse vem do painel com
                            quebras de parágrafo de verdade. Sem isso o texto
                            desaba num bloco só. */}
                        <p
                          className="text-white/75 text-sm md:text-[15px] leading-relaxed
                                     whitespace-pre-line max-w-[72ch] line-clamp-5"
                        >
                          {texto}
                        </p>
                        {/* "Ler mais" leva à página do livro: é lá que estão a
                            sinopse inteira, a ficha completa e as opiniões. */}
                        <Link
                          to={linkLivro}
                          onClick={scrollUp}
                          className="link-sublinhado inline-block mt-2.5 text-sm font-semibold text-insigne-orange"
                        >
                          Ler mais
                        </Link>
                      </div>
                    )}

                    {/* ===== Rodapé: as duas ações ===== */}
                    {/* A divisória usa `white/10` e não `border-line`: no tema escuro o
                        token de linha é quase a mesma cor da superfície do card
                        (é assim de propósito, para não haver halo claro em volta
                        dos cards) e a divisória simplesmente sumia. */}
                    <div className="mt-6 pt-5 border-t border-white/10 flex flex-wrap items-center gap-3">
                      {/* "Ver mais" é a ação principal e leva à página do
                          livro, onde estão preço, formato e carrinho. Sem seta
                          no rótulo: seta em botão não é do vocabulário do
                          site. */}
                      <Link
                        to={linkLivro}
                        onClick={scrollUp}
                        className="inline-flex items-center gap-2 rounded-controle
                                   border-2 border-insigne-orange-dark bg-insigne-orange text-paper
                                   px-6 py-2.5 text-sm font-semibold
                                   shadow-[3px_3px_0_0_rgb(var(--c-orange-dark))]
                                   transition-[box-shadow,background-color] duration-150
                                   hover:bg-insigne-orange-alt hover:shadow-[5px_5px_0_0_rgb(var(--c-orange-dark))]"
                      >
                        Ver mais
                      </Link>

                      {/* "Leia um trecho" só existe se houver PDF: um botão
                          que abre um leitor vazio é pior do que botão nenhum. */}
                      {pdf && (
                        <button
                          type="button"
                          onClick={() => setTrechoAberto(true)}
                          className="inline-flex items-center gap-2 rounded-controle border-2 border-insigne-orange
                                     px-5 py-2.5 text-sm font-semibold text-insigne-orange
                                     transition-colors hover:bg-insigne-orange hover:text-paper"
                        >
                          <i className="bi bi-book-half" /> Leia um trecho
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </SpotlightCard>
            </div>
          </BorderGlow>
          </div>
        </Reveal>

      {/* O leitor de trecho é o MESMO da página do livro — mesma rota de
          preview no backend, mesmo comportamento em celular (baixa o PDF,
          porque iframe de PDF não funciona ali). */}
      {trechoAberto && (
        <ModalPreview
          pdfUrl={`${API_URL}get-pdf-preview?pdf_path=${pdf}`}
          onClose={() => setTrechoAberto(false)}
        />
      )}
    </Vitrine>
  );
};

export default EspecialDaCasa;
